<sat-popover
  #popRef
  [autoFocus]="false"
  [restoreFocus]="false"
  horizontalAlign="center"
  verticalAlign="start"
  hasBackdrop>
  <mat-card class="__pop  z-manual-elevation  c-soft-elevation">

    <span class="__desc">{{ title() }}</span>

    <z-client-user-select
      [data]="clientUsers()"
      (selected)="onSelectClientUser$.next($event); popRef.close();">
    </z-client-user-select>

    <div class="fx:px-1 fx:pt-0-5">
      <button
        mat-stroked-button
        type="button"
        class="c-button--smaller c-button--full"
        (click)="popRef.close(); onCreateOrganization$.next();">
        <mat-icon>add</mat-icon>
        Create organization
      </button>
    </div>

  </mat-card>
</sat-popover>
